import React, { useState } from 'react';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import { RegularButton } from 'pg-ui-library';
import { PersonalDependentsModal } from 'src/modules/personal-info/components/personal-dependents-modal';
import DependentTable from 'src/modules/personal-info/components/dependent-form-table';
import { MainTitle } from './styles';

const ContactsTable: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useTypedSelector(state => state.personalInfo);

  return (
    <div style={{ width: '100%' }}>
      <PersonalDependentsModal updateDependent={[]} isOpen={isOpen} setIsOpen={setIsOpen} isUpdate={false} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <MainTitle>{t('benefits.contacts.table.header')}</MainTitle>

        <RegularButton type="button" style={{ marginRight: '40px', marginTop: '13px' }} onClick={() => setIsOpen(true)}>
          {t('global.form.add')}
        </RegularButton>
      </div>
      <div>
        <DependentTable personalInfo={data.personalInfo} />
      </div>
    </div>
  );
};

export default ContactsTable;
